import { render, staticRenderFns } from "./createOverseaOrder.vue?vue&type=template&id=2134985c&scoped=true"
import script from "./createOverseaOrder.vue?vue&type=script&lang=js"
export * from "./createOverseaOrder.vue?vue&type=script&lang=js"
import style0 from "./createOverseaOrder.vue?vue&type=style&index=0&id=2134985c&prod&scoped=true&lang=css"
import style1 from "./createOverseaOrder.vue?vue&type=style&index=1&id=2134985c&prod&lang=css"
import style2 from "./createOverseaOrder.vue?vue&type=style&index=2&id=2134985c&prod&scoped=true&lang=scss"
import style3 from "./createOverseaOrder.vue?vue&type=style&index=3&id=2134985c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134985c",
  null
  
)

export default component.exports